import { Monitor } from './monitor.type';
import { ScheduleStatus } from '../../enums/schedule-status.enum';
import { PlaylistDTO } from '../view-models/playlist-models/playlist-dto.model';
import { MonitorScheduleInterface } from '../../interfaces/monitor-schedule.interface';

export class Schedule {
  Id: number;
  PlaylistId: number;
  MonitorHandler: string;
  MachinePhysicalAddress: string;
  On: boolean;
  ScheduleType: number;
  AllDay: boolean = false;
  StartTime: string = null;
  EndTime: string = null;

  Monday: boolean = false;
  Tuesday: boolean = false;
  Wednesday: boolean = false;
  Thursday: boolean = false;
  Saturday: boolean = false;
  Friday: boolean = false;
  Sunday: boolean = false;

  StartDate: string = null;
  EndDate: string = null;

  ScheduleStatus: ScheduleStatus;

  Playlist: PlaylistDTO;
  Monitor: Monitor;

  Monitors?: MonitorScheduleInterface[];

  constructor(values: Partial<Schedule> = {}) {
    Object.assign(this, values);
  }
}
